import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingAiImageDetectorConfig } from '@/data/landingConfig/landingAiImageDetectorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AiImageDetector } from './schemaObject';

interface Props {}
const AiImageDetector: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_AiImageDetector} />
			<LandingTemplate
				data={landingAiImageDetectorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelAiImageDetector()}
			/>
		</>
	);
};

export default AiImageDetector;
